import { ActionReducerMap } from '@ngrx/store';
import { StoreKeysEnum } from '@core/enums/store-keys.enum';
import { systemReducer } from '@store/system/system.reducer';
import { SystemState } from '@store/system/system-state.model';

export interface AppState {
    [StoreKeysEnum.SYSTEM]: SystemState;
}

export const reducers: ActionReducerMap<AppState> = {
    [StoreKeysEnum.SYSTEM]: systemReducer,
};
